export const FaceBookLoginConstants = {
	PROVIDER_NAME: 'Facebook',
	APP_ID: '1202887856933105',
}
